import React from 'react';
import FormWizard from '../FormWizard';
import UniformForm from './UniformForm';

const UniformFormPage = () => {
  return (
    <FormWizard
      formId={3}
      formTitle="Uniform Form"
      formTitleEs="Formulario de Uniforme"
    >
      <UniformForm />
    </FormWizard>
  );
};

export default UniformFormPage;
